export const userTypeEnum = {
    User: 'User',
    OPU: 'OPU',
    Public_OPU: 'Public_OPU',
    Company: 'Company',
    OperationManager: 'Operation_Manager',
    Administrator: 'Administrator',
};
